export const serialize = form => {
  let field, s = {};
  if (typeof form === 'object' && form.nodeName === "FORM") {
    let len = form.elements.length;
    for (let i = 0; i < len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
        if (field.type === 'select-multiple') {
          for (j = form.elements[i].options.length - 1; j >= 0; j--) {
            if (field.options[j].selected)
              if (field.options[j].value) s[field.name] = field.options[j].value;
          }
        } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
          if (field.value) s[field.name] = field.value;
        }
      }
    }
  }
  return s
}

export const config = (config, name) => {
  if (!config) return "";
  let results = config.match(new RegExp(name + "=([^&]*)")); // config.match(/\w+\=\s?\w+(?=,?\s?)/)
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export const urlParams = obj => {
  let str = ''
  for (let key in obj) {
    if (obj[key]) {
      if (str) str += "&"
      str += key + "=" + encodeURIComponent(obj[key]);
    }
  }
  return str
}

export const widgetUrl = (options, extra = {}) => {
  const {
          account, env, externalId
        }      = options,
        locale = navigator.language || navigator.userLanguage || 'en-US',
        params = urlParams({
          locale,
          pp: 'disabled',
          external_id: externalId || null,
          ...extra
        })

  switch(env) {
    case 'development':
      return `${location.protocol}//${location.host}/widget?${params}`
    case 'staging':
      return `https://${account}.bookthatapp-staging.com/widget?${params}`
    case undefined:
      return `https://${account}.bookthatapp.com/widget?${params}`
    default:
      return `${env}/widget?${params}`
  }

}

export const timeFormat = () => {
  const locale = navigator.language || navigator.userLanguage || 'en-US'
  return locale.substr(0, 2) === 'en' ? 'hh:mm A' : 'HH:mm'
}

export const inBta = () => {
  return !!/\.bookthatapp/.exec(location.host)
}

export const inTestPage = () => {
  return !!(inBta() && /^\/tests\//.exec(location.pathname))
}

export const inShopifyCartPage = () => {
  const cartPage = /^\/cart/.exec(location.pathname)
  return !!(!inBta() && cartPage)
}

export const inShopifyProductPage = () => {
  const productPage = /\/products/.exec(location.pathname),
        form        = document.querySelector('form[action="/cart/add"]')
  return !!(!inBta() && productPage && form)
}

export const inAdminWidgetPage = () => {
  return !!(inBta() && /^\/admin\/widgets\//.exec(location.pathname))
}

export const widgetIdInPath = () => {
  const result = /^\/admin\/widgets\/(\d+)/.exec(location.pathname)
  return result ? result[1] : null
}
